/**
 * index.js
 * Written by: Alex Kasemir
 * Combines all of the actions contained in this directory
 */
import * as get from './getUser';
import * as facebookLogin from './facebookLogin';
import * as gmailLogin from './gmailLogin';
import * as authenticateFacebook from './authenticateFacebook';
import * as loadSession from './loadSession';
import * as setAuthedUser from './setAuthedUser';
import * as loadToken from './loadToken';
import * as removeToken from './removeToken';
import * as refreshToken from './refreshToken';
import * as checkExpiredToken from './checkExpiredToken';
import * as authenticateGmail from './authenticateGmail';
import * as selectUser from './selectUser';
import * as getUserStats from './getUserStats';
import * as getUserStatsByCategory from './getUserStatsByCategory';
import * as getUserQuestions from './getUserQuestions';
import * as getUserBestWorst from './getUserBestWorst';
import * as logout from './logout';
import * as patchUsername from './patchUsername';
import * as validateReferral from './validateReferral';
import * as getUserBadges from './getUserBadges';
import * as createSubscriber from './createSubscriber';
import * as selectProfileInfo from './selectProfileInfo';
import * as getUserPreferences from './getUserPreferences';
import * as updateUserPreferences from './updateUserPreferences';
import * as activateUser from './activateUser';
import * as selectUserPreferences from './selectUserPreferences';
import * as updateCampaign from './updateCampaign';

export default {
  ...get,
  ...facebookLogin,
  ...gmailLogin,
  ...authenticateFacebook,
  ...authenticateGmail,
  ...loadSession,
  ...setAuthedUser,
  ...loadToken,
  ...removeToken,
  ...refreshToken,
  ...checkExpiredToken,
  ...selectUser,
  ...getUserStats,
  ...getUserStatsByCategory,
  ...getUserQuestions,
  ...logout,
  ...patchUsername,
  ...validateReferral,
  ...getUserBadges,
  ...createSubscriber,
  ...selectProfileInfo,
  ...updateUserPreferences,
  ...getUserPreferences,
  ...activateUser,
  ...selectUserPreferences,
  ...getUserBestWorst,
  ...updateCampaign,
};
